/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { IHomeworkInfo, IResponse } from '@umu/umu-types';

interface IInput {
    homework_id: number;
}

export const getHomeworkInfo = fetchDataSync((data: IInput): Promise<IResponse<IHomeworkInfo>> => {
    const config = Object.assign({}, Api.GET_HOMEWORK_INFO, {
        url: Api.GET_HOMEWORK_INFO.url + '/' + data.homework_id,
    });
    return fetchData(config).then((res: IResponse<IHomeworkInfo>) => {
        return res;
    });
});
export const fetchHomeworkInfo = (data: IInput): Promise<IResponse<IHomeworkInfo>> => {
    const config = Object.assign({}, Api.GET_HOMEWORK_INFO, {
        url: Api.GET_HOMEWORK_INFO.url + '/' + data.homework_id,
    });
    return fetchData(config).then((res: IResponse<IHomeworkInfo>) => {
        return res;
    });
};
